import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "items": _vm.list,
      "headers": _vm.tableHeaders,
      "search": _vm.searchItem,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "70px"
          }
        }, [_vm._v(_vm._s(items.item.id))]), _c('td', [_vm._v(_vm._s(items.item.title))]), _c('td', [_vm._v(_vm._s(items.item.eui))]), _c('td', [items.item.error === false ? _c('span', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-check")])], 1) : _vm._e(), items.item.error ? _c('span', [_c(VIcon, {
          attrs: {
            "color": _vm.getColor('error'),
            "small": ""
          }
        }, [_vm._v("fal fa-times")])], 1) : _vm._e()]), _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.deleteFromList(items.item);
            }
          }
        }, [_vm._v("\n            fal fa-trash-alt\n          ")])], 1)]), items.item.error ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "5"
          }
        }, [_c(VAlert, {
          attrs: {
            "color": _vm.getColor('error'),
            "dark": "",
            "dense": "",
            "type": "error"
          }
        }, [_vm._v("\n            " + _vm._s(items.item.errorMsg) + "\n          ")])], 1)]) : _vm._e()];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };